import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
    label: string;
    color: "gray" | "green" | "red" | "blue";
}

export const SmallBadgeCard: React.FC<Props> = (
    {
        label,
        color
    }
) => {
    const getBackgroundColor = () => {
        switch (color) {
            case "green":
                return theme.palette.primitives.green100;
            case "red":
                return theme.palette.primitives.red100;
            case "blue":
                return theme.palette.primitives.blue100;
            default:
                return theme.palette.primitives.gray100;
        }
    };

    const getColor = () => {
        switch (color) {
            case "green":
                return theme.palette.primitives.green500;
            case "red":
                return theme.palette.primitives.red500;
            case "blue":
                return theme.palette.primitives.blue500;
            default:
                return theme.palette.primitives.gray400;
        }
    };

    return (
        <BadgeCardContainer>
            <BadgeCardContent
                backgroundColor={getBackgroundColor()}
                color={getColor()}
            >
                {label}
            </BadgeCardContent>
        </BadgeCardContainer>
    );
};

const BadgeCardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface BadgeCardProps {
    backgroundColor: string;
    color: string;
}

const BadgeCardContent = styled.div<BadgeCardProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 0.7rem;
  line-height: 0.875rem;
  color: ${(props) => props.color};
  background-color: ${(props) => props.backgroundColor};
`;
